import { render, staticRenderFns } from "./WebTaskEditForm.vue?vue&type=template&id=ebfa64fe&scoped=true&"
import script from "./WebTaskEditForm.vue?vue&type=script&lang=ts&"
export * from "./WebTaskEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfa64fe",
  null
  
)

export default component.exports